import styled from 'styled-components';

export const TouchContainer = styled.div``;
